enum Permission {
    // VIEW_VALIDATIONS = 'view-validation',
    // VIEW_DASHBOARDS = 'view-dashboards',
    // SUPER_ADMIN = 'super-admin',
    USERS_VIEW = 'users_view',
    USERS_CREATE = 'users_create',
    USERS_UPDATE = 'users_update',
    USERS_DELETE = 'users_delete',

    DASHBOARD_VIEW = 'dashboard_view',
    DASHBOARD_CREATE = 'dashboard_create',
    DASHBOARD_UPDATE = 'dashboard_update',
    DASHBOARD_DELETE = 'dashboard_delete',

    DASHBOARD_ADMIN_VIEW = 'dashboard-admin_view',
    DASHBOARD_ADMIN_CREATE = 'dashboard-admin_create',
    DASHBOARD_ADMIN_UPDATE = 'dashboard-admin_update',
    DASHBOARD_ADMIN_DELETE = 'dashboard-admin_delete',
    DASHBOARD_ADMIN_SHARE_GLOBAL = 'dashboard-admin_share-global',

    SALARY_STATUS_VIEW = 'salary-status_view',

    SALARY_PAYSLIPS_VIEW = 'salary-payslips_view',
    SALARY_PAYSLIPS_CREATE = 'salary-payslips_create',
    SALARY_PAYSLIPS_UPDATE = 'salary-payslips_update',
    SALARY_PAYSLIPS_DELETE = 'salary-payslips_delete',

    SALARY_PAYROLLS_VIEW = 'salary-payrolls_view',
    SALARY_PAYROLLS_CREATE = 'salary-payrolls_create',
    SALARY_PAYROLLS_UPDATE = 'salary-payrolls_update',
    SALARY_PAYROLLS_DELETE = 'salary-payrolls_delete',

    SALARY_COMPANY_VIEW = 'salary-company_view',
    SALARY_COMPANY_UPDATE = 'salary-company_update',

    EMPLOYEES_VIEW = 'employees_view',
    EMPLOYEES_CREATE = 'employees_create',
    EMPLOYEES_UPDATE = 'employees_update',

    EMPLOYEES_IMPORT_CREATE = 'employees-import_create',
    EMPLOYEES_ADMIN_IMPORT_CREATE = 'employees-admin-import_create',

    HOLIDAY_PAY_OBLIGATIONS_VIEW = 'holiday-pay-obligations_view',
    HOLIDAY_PAY_OBLIGATIONS_CREATE = 'holiday-pay-obligations_create',
    HOLIDAY_PAY_OBLIGATIONS_UPDATE = 'holiday-pay-obligations_update',
    HOLIDAY_PAY_OBLIGATIONS_DELETE = 'holiday-pay-obligations_delete',

    VOUCHERS_VIEW = 'vouchers_view',
    VOUCHERS_UPDATE = 'vouchers_update',

    VOUCHERS_EARLIER_RELEASES_VIEW = 'vouchers-earlier-releases_view',

    VOUCHERS_ADMIN_VIEW = 'vouchers-admin_view',
    VOUCHERS_ADMIN_CREATE = 'vouchers-admin_create',
    VOUCHERS_ADMIN_UPDATE = 'vouchers-admin_update',
    VOUCHERS_ADMIN_DELETE = 'vouchers-admin_delete',

    // Vouchers own
    VOUCHERS_OWN_VIEW = 'vouchers-own_view',
    VOUCHERS_OWN_UPDATE = 'vouchers-own_update',

    // Vouchers dimensions
    VOUCHERS_DIMENSIONS_VIEW = 'vouchers_dimensions-view',

    BANK_VIEW = 'bank-module_view',
    BANK_CREATE = 'bank-module_create',
    BANK_UPDATE = 'bank-module_update',
    BANK_DELETE = 'bank-module_delete',

    // VAT
    VAT_VIEW = 'vat_view',
    VAT_UPDATE = 'vat_update',

    POWERBI_VIEW = 'powerbi_view',
    POWERBI_SETUP_VIEW = 'powerbi-setup_view',
    POWERBI_SETUP_CREATE = 'powerbi-setup_create',
    POWERBI_SETUP_UPDATE = 'powerbi-setup_update',
    POWERBI_SETUP_DELETE = 'powerbi-setup_delete',

    TRANSLATIONS_VIEW = 'translations_view',

    SYSTEM_VIEW = 'system_view',
    SYSTEM_CREATE = 'system_create',
    SYSTEM_UPDATE = 'system_update',
    SYSTEM_DELETE = 'system_delete',

    ACTIVITIES_VIEW = 'activities_view',

    HOLIDAYS_VIEW = 'holidays_view',
    HOLIDAYS_CREATE = 'holidays_create',
    HOLIDAYS_UPDATE = 'holidays_update',
    HOLIDAYS_DELETE = 'holidays_delete',

    ROLES_VIEW = 'roles_view',
    ROLES_CREATE = 'roles_create',
    ROLES_UPDATE = 'roles_update',
    ROLES_DELETE = 'roles_delete',

    WORK_CALENDARS_VIEW = 'work-calendars_view',
    WORK_CALENDARS_CREATE = 'work-calendars_create',
    WORK_CALENDARS_UPDATE = 'work-calendars_update',
    WORK_CALENDARS_DELETE = 'work-calendars_delete',

    COMPANIES_VIEW = 'companies_view',
    COMPANIES_CREATE = 'companies_create',
    COMPANIES_UPDATE = 'companies_update',
    COMPANIES_DELETE = 'companies_delete',

    OUTLAY_VIEW = 'outlay_view',

    // Credit cards
    CREDIT_CARDS_VIEW = 'credit-cards_view',
    CREDIT_CARDS_CREATE = 'credit-cards_create',
    CREDIT_CARDS_UPDATE = 'credit-cards_update',
    CREDIT_CARDS_DELETE = 'credit-cards_delete',

    // Vouchers administrate
    VOUCHERS_ADMINISTRATE_CARDS = 'vouchers_administrate-cards',
    VOUCHERS_ADMINISTRATE_FALLBACK = 'vouchers_administrate-fallback',

    // Onboarding
    ONBOARDING_VIEW = 'onboarding_view',
    ONBOARDING_CREATE = 'onboarding_create',
    ONBOARDING_UPDATE = 'onboarding_update',
    ONBOARDING_DELETE = 'onboarding_delete',
    ONBOARDING_UPDATE_STATUS = 'onboarding_update-status',

    // Global Search
    GLOBAL_SEARCH_SEARCH = 'global-search_search',

    TASK_TEMPLATES_VIEW = 'task-templates_view',
    TASK_TEMPLATES_CREATE = 'task-templates_create',
    TASK_TEMPLATES_UPDATE = 'task-templates_update',
    TASK_TEMPLATES_DELETE = 'task-templates_delete',

    TEST_DENY = 'test_deny',
}

export default Permission;
